export const XSpiceActionSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={(width / 17) * 15}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_219_439)">
        <path
          d="M8.5 0L15.8612 12.75H1.13878L8.5 0Z"
          fill="url(#paint0_linear_219_439)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_219_439"
          x="0.138794"
          y="0"
          width="16.7224"
          height="14.75"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.76 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_219_439"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_219_439"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_219_439"
          x1="8.5"
          y1="0"
          x2="8.5"
          y2="17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2AF1B" />
          <stop offset="0.208333" stopColor="#EEB51A" />
          <stop offset="0.458333" stopColor="#E4C418" />
          <stop offset="0.729167" stopColor="#EE991A" />
          <stop offset="1" stopColor="#F08E1B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
